import Filter from "./modules/Filter";
import Roller from "./modules/Roller";
import Description from "./modules/Description";

document.addEventListener("DOMContentLoaded", () => {
    // Add all your JS modules here:
    const filter = new Filter();
    const roller = new Roller(filter);
    const description = new Description();

    const closeBanner = document.querySelector(".donate__close");
    if (closeBanner) {
        const banner = document.querySelector(".donate");
        if (sessionStorage && sessionStorage.getItem("donation") == "hide") {
            banner.remove();
        }
        closeBanner.addEventListener("click", () => {
            sessionStorage.setItem("donation", "hide");
            banner.remove();
        });
        const dialogButton = banner.querySelector(".donate__dialog-button");
        const dialog = banner.querySelector(".donate__dialog");
        dialogButton.addEventListener("click", () => {
            dialog.showModal();
            document.body.style.overflow = "hidden";
        });
        dialog.addEventListener("click", () => {
            dialog.close();
            document.body.removeAttribute("style");
        });
    }
});
